import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const styles = {
  collectionList: {
    container: css`
      display: flex;
      flex-direction: column;
      gap: ${theme.spacing(3)};
    `,
    containerMobile: css`
      gap: 0;
    `,
    syncInfo: css`
      display: flex;
      align-items: center;
      gap: ${theme.spacing(1)};
    `,
  },
  collectionsSummary: {
    mobileWrapper: css`
      padding: ${theme.spacing(2, 3)};
      border-bottom: 1px solid ${theme.colors.neutral20};
    `,
  },
  filtersOnMobile: {
    container: css`
      display: flex;
      align-items: center;
      gap: ${theme.spacing(2)};
      padding: ${theme.spacing(0, 3)};
    `,
    dropdownFilter: css`
      width: unset;
      max-width: unset;
    `,
    searchWrapper: css`
      display: flex;
      align-items: center;
      flex: 1;
      > div {
        width: 100%;
      }
    `,
    searchField: css`
      width: 100%;
    `,
    popoverDialog: css`
      display: flex;
      flex-direction: column;
      gap: ${theme.spacing(2)};
      width: 250px;
    `,
    actionButtonsRow: css`
      display: flex;
      justify-content: space-between;
    `,
    applyButton: css`
      width: 100%;
    `,
  },
  filterPanel: {
    checkboxList: css`
      display: flex;
      flex-direction: column;
      gap: ${theme.spacing(1)};
    `,
  },
  topToolbarDesktop: {
    container: css`
      display: flex;
      align-items: center;
      flex: 1;
      gap: ${theme.spacing(2)};
      padding-left: ${theme.spacing(2)};
    `,
    actionsContainer: css`
      display: flex;
      align-items: center;
      flex: 1;
      justify-content: flex-end;
      gap: ${theme.spacing(2)};
    `,
    button: css`
      text-transform: none;
    `,
  },
  topToolbarMobile: {
    container: css`
      display: flex;
      align-items: center;
      gap: ${theme.spacing(1)};
      padding: ${theme.spacing(1, 3)};
      border-bottom: 1px solid ${theme.colors.neutral20};
    `,
    selectionActions: css`
      display: flex;
      flex: 1;
      gap: ${theme.spacing(2)};
    `,
    selectionActionsHidden: css`
      visibility: hidden;
    `,
    nakedButton: css`
      cursor: pointer;
      text-decoration: underline;
      color: ${theme.colors.primary50};
    `,
    button: css`
      text-transform: none;
    `,
  },
};
